import { render, staticRenderFns } from "./StudentVisaDocuments.vue?vue&type=template&id=5b2c31a7&"
import script from "./StudentVisaDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentVisaDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StudentVisaDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports